<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >

      <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
        <a-form-model-item label="类型" prop="type" :help="formErr.type" :validateStatus='!formErr.type||formErr.type==""?"":"error"'>
          <a-select v-model="form.type" class="seachs" placeholder="请选择" disabled>
            <a-select-option :value="1">
              策略报告
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="ai_prompt" label="指令词" prop="ai_prompt" :help="formErr.ai_prompt" :validateStatus='!formErr.ai_prompt||formErr.ai_prompt==""?"":"error"' >
          <a-input type="textarea"
                   :maxLength=3000
                   v-model="form.ai_prompt"
                   @change="(e) => { formErr.ai_prompt=''}"
                   @blur="(e) => {  form.ai_prompt = e.target.value.trim();}" />
        </a-form-model-item>
      </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../../utils/utils"
    import API from "../api";
    import moment from 'moment';
    export default {
        name: "instructionForm",
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},
        },
        data() {
            return {
                drawerConfig ,
                form: {type:1,
                  ai_prompt:"",
                },
                formErr: {
                  type:'',
                  ai_prompt:"",
                },
                rules: {
                  ai_prompt: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders(rule, value, callback)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16},
                },
            };
        },
        watch:{
            visible:function(){
                if(this.visible && this.title.indexOf('添加') !== -1){
                    this.form.type = 1
                }
            },
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''

                }
            }
        },
        mounted(){
        },
        methods: {
            validatePlaceholders(rule, value, callback) {
                if (!value) {
                    this.formErr.ai_prompt = '请输入内容'
                    callback(new Error('请输入内容'))
                    return
                }
                const requiredPlaceholders = ['{keyword}', '{product_type}', '{classified_products}', '{application_scenarios}', '{group_portrait}', '{country}', '{marketing_goals}']
                const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
                if (missing.length > 0) {
                    const placeholderNames = {
                        '{keyword}': '{keyword}',
                        '{product_type}': '{product_type}',
                        '{classified_products}': '{classified_products}',
                        '{application_scenarios}': '{application_scenarios}',
                        '{group_portrait}': '{group_portrait}',
                        '{country}': '{country}',
                        '{marketing_goals}': '{marketing_goals}'
                    }
                    const missingNames = missing.map(p => placeholderNames[p])
                    this.formErr.ai_prompt = `句式中须包含${missingNames.join('、')}`
                    callback(new Error(`句式中须包含${missingNames.join('、')}`))
                } else {
                    this.formErr.ai_prompt = ''
                    callback()
                }
            },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                  type:'',
                  ai_prompt:"",
                }
              this.form = {
                type: 1,
                ai_prompt: "",
              },
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))

                      this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT

                      submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
form .ant-mentions, form textarea.ant-input {
  height: 350px;
}
</style>
